<template>
  <div style="">
    <analytics-header :title="title"/>
    <div>
      <div class="tabs">
        <span class="tab" :class="{selected: range==='week', button: range!=='week'}"
              @click="changeRange('week')">7日間</span>
        <span class="tab" :class="{selected: range==='month', button: range!=='month'}"
              @click="changeRange('month')">30日間</span>
      </div>
      <canvas ref="chartCanvas"></canvas>
    </div>
  </div>
</template>

<script>
import AnalyticsHeader from "./AnalyticsHeader";
export default {
  name: "BarChartWithTitle",
  components: {AnalyticsHeader},
  props: {
    title: { type: String },
    chartConfig: { type: Object }
  },
  data() {
    return {
      range: 'week',
      chart: null,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    changeRange(range) {
      this.range = range
      this.chart.destroy()
      this.init()
    },
    init() {
      const ctx = this.$refs['chartCanvas'].getContext('2d');
      const myChart = new Chart(ctx, this.chartConfig[this.range]);
      myChart.canvas.parentNode.className = 'chartParent'
      this.chart = myChart
    }
  }
}
</script>

<style scoped>
h3 {
  color: white;
  background: #e74a23;
  background: linear-gradient(124deg,#e74a23,#e9671f,#ec841b,#efa118);
  padding: 1.4vh 0;
  font-size: 3vh;
}
.tabs {
  margin-bottom: 1vh;
}
.tab {
  padding: 1vh;
}
.tab.selected {
  border-bottom: 2px solid #e74a23;
}
.tab.button {
  border-radius: 0.5vh;
  background: #e74a23;
  background: linear-gradient(30deg, #e74a23 0%, #efa118 80%, #ffe140 100%);
  box-shadow: 0.3vh 0.3vh 0.3vh rgba(0,0,0,0.3);
  font-weight: bold;
  color: white;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/analytics/BarChartWithTitle.vue